import React from 'react'
import propTypeSchema from 'react-json-schema-proptypes'
import { Typography } from '../types'
import { markdown, valueOrUndefined } from '../common'
import Radium, {Style} from 'radium'

const schema = {
  'type': 'object',
  'required': ['text'],
  'properties': {
    'text': { 'type': 'string' },
    'textStyle': Typography.Schema,
    'strongStyle': Typography.Schema
  }
}

@Radium
export default class BetaSidebar extends React.PureComponent {
  static propSchema = schema
  static propTypes = propTypeSchema(schema, {
    'required': ['assetLoader'],
    'properties': {
      'assetLoader': { 'isFunction': true }
    }
  })

  static defaultProps = {
    textStyle: {
      color: '#000000'
    },
    strongStyle: {
      color: '#000000',
      fontSize: '1em'
    }
  }

  render () {
    const styles = {
      text: valueOrUndefined(this.props, 'textStyle')
    }

    return ( <div className={'beta'}>
      <span className={'rightText'} style={[styles.text]}>
        <Style
          scopeSelector=".rightText"
          rules={{
            strong: {
              color: this.props.strongStyle.color,
              fontSize: this.props.strongStyle.fontSize
            }
          }}
        />
        {markdown(this.props.text)}
      </span>
    </div>
    )
  }
}
